<template>
    <div>
        <el-row class="full_height">
            <el-col :span="4" class="positon_relative">
                <el-menu class="nav_menu" text-color="#A7CCF6"  default-active="1" active-text-color="#fff">
                    <router-link :to="{name:'dayReportNew'}" class="link" v-if="this.mainId==158 || this.mainId==137 || this.mainId==138 || this.mainId >= 213">
                        <el-menu-item index="1">
                          <template slot="title">
                            <i class="el-icon-date"></i>&nbsp;日报表
                          </template>
                        </el-menu-item>
                    </router-link>
                  <router-link :to="{name:'dayreport'}" class="link" v-else>
                    <el-menu-item index="1">
                      <template slot="title">
                        <i class="el-icon-date"></i>&nbsp;日报表
                      </template>
                    </el-menu-item>
                  </router-link>
                    <!-- <router-link :to="{name:'WeekReport'}" class="link">
                        <el-menu-item index="2">
                            <i class="iconfont icon-file-chart-pie"></i>&nbsp;周报表
                        </el-menu-item>
                    </router-link> -->
                    <router-link :to="{name:'MonthReportNew'}" class="link" v-if="this.mainId==158 || this.mainId==137 || this.mainId==138 || this.mainId >= 213">
                        <el-menu-item index="2">
                          <template slot="title">
                            <i class="el-icon-date"></i>&nbsp;月报表
                          </template>
                        </el-menu-item>
                    </router-link>
                  <router-link :to="{name:'MonthReport'}" class="link" v-else>
                    <el-menu-item index="2">
                      <template slot="title">
                        <i class="el-icon-date"></i>&nbsp;月报表
                      </template>
                    </el-menu-item>
                  </router-link>

<!--                    <router-link :to="{name:'YearReport'}" class="link">
                        <el-menu-item index="3">
                          <template slot="title">
                            <i class="el-icon-date"></i>&nbsp;年报表
                          </template>
                        </el-menu-item>
                    </router-link>-->
                </el-menu>
            </el-col>
            <el-col :span="20" class="full_height">
                <router-view class="full_height tab_content"></router-view>
            </el-col>
        </el-row>
<!--        <home-footer></home-footer>-->
        </div>
</template>

<script>
// import HomeFooter from '../../components/Footer'

export default {
  components: {
    // HomeFooter,
  },
  data() {
    return {
      mainId: localStorage.getItem("mainId")
    };
  },
  mounted: function () {
    console.log("report mounted...")
    if (this.mainId==158 || this.mainId==137 || this.mainId==138 || this.mainId >= 213){
      this.$router.push({"name": "dayReportNew"})
    } else {
      this.$router.push({"name": "dayreport"})
    }
  }
}
</script>

<style scoped>
    @import "../../assets/css/style.css";
</style>





// WEBPACK FOOTER //
// src/components/reportManage/index.vue